export class Config {
    static get(name: string): string {
        // @ts-ignore
        return window.APP_CONFIG[name];
    }
}
